import { PieChartCard } from '../PieChartCard'
import { OverviewHeaderProps } from './interface'

export function OverviewHeader({
  sales,
  donation,
  genderDetail,
  ageDetail,
  reportList,
}: OverviewHeaderProps) {
  return (
    <>
      <div className='flex desktop:space-x-[20px] pb-[20px] tablet-mobile:grid tablet-mobile:gap-[20px]'>
        <div className='bg-sale-analytic bg-cover w-full rounded-[8px] text-center font-light text-[16px] text-white-1 px-[100px] py-[30px] mobile:text-[14px] mobile:bg-contain mobile:py-[12px] mobile:grid mobile:grid-cols-1 mobile:px-0'>
          รายได้จากการขาย
          <span className='font-bold text-[36px] px-[20px] mobile:text-[24px] text-white'>
            {sales.toLocaleString()}
          </span>
          เหรียญ
        </div>
        <div className='bg-sale-analytic bg-cover w-full rounded-[8px] text-center font-light text-[16px] text-white-1 px-[100px] py-[30px] mobile:text-[14px] mobile:bg-contain mobile:py-[12px] mobile:grid mobile:grid-cols-1 mobile:px-0'>
          รายได้จากการสนับสนุน
          <span className='font-bold text-[36px] px-[20px] mobile:text-[24px] text-white'>
            {donation.toLocaleString()}
          </span>
          เหรียญ
        </div>
      </div>
      <div className='flex justify-between place-content-center justify-items-center tablet-mobile:grid tablet-mobile:grid-cols-2 tablet-mobile:gap-[20px]'>
        {reportList.map(item => (
          <div
            key={`${item.id}`}
            className='flex flex-col shadow-card bg-white dark:bg-dark-9 rounded-[8px] border border-gray-4 dark:border-purple w-[270px] py-[30px] mobile:py-[20px] mobile:w-[164px]'
          >
            <div className='flex justify-center'>
              <div className='flex w-[120px] h-[120px] bg-gray-4 dark:bg-dark-9 rounded-full justify-center items-center mobile:w-[58px] mobile:h-[58px]'>
                {item.icon}
              </div>
            </div>
            <div className='flex justify-center pt-[10px] text-secondary dark:text-dark-10 text-[32px] font-bold'>
              {item.value.toLocaleString()}
            </div>
            <div className='flex justify-center pt-[5px] text-secondary-1 font-light'>
              {item.text}
            </div>
          </div>
        ))}
      </div>
      <div className='flex justify-between space-x-[20px] pt-[20px] tablet-mobile:hidden'>
        <PieChartCard title='เพศ' data={genderDetail} legendStyle='left' />
        <PieChartCard title='ช่วงอายุ' data={ageDetail} legendStyle='left' />
      </div>
      <div className='pt-[20px] gap-[20px] tablet-mobile:grid mobile:grid-cols-1 tablet:grid-cols-2 desktop:hidden'>
        <PieChartCard title='เพศ' data={genderDetail} legendStyle='bottom' />
        <PieChartCard title='ช่วงอายุ' data={ageDetail} legendStyle='bottom' />
      </div>
    </>
  )
}
